<template>
	<modal @close="$emit('close')" :clickBackdropClosing="false" width="98%" :showModalCloseButton="false" :noTitleBar="true" :forceHeight="forceHeight" :maxWidth="maxWidth">
		<div slot="footer">
			<div class="d-flex align-items-center px-2 py-2">
				<div style="flex-grow:1;"></div>
				<div class="text-right">
					<button v-if="hasSoldOut" class="btn btn-sm btn-secondary ml-3" style="word-break:keep-all;" @click="$emit('close')">
						{{ $t('general.close') }}
					</button>
					<button v-else class="btn btn-sm btn-primary ml-3" style="word-break:keep-all;" @click="confirm">
						{{$t('booking_passes.buy_pass')}}
					</button>
				</div>
			</div>
		</div>
		<div>
			<div class="popup-gray-close-button absolute" @click="$emit('close')">
				<img src="/img/close_cross@2x.png" />
			</div>
			<inline-photo-viewer
				v-if="imageItems.length"
				:images="imageItems"
				:context="context"
				:provider="provider"
			/>

			<div style="clear:both;"></div>

			<booking-pass-content
				:context="context"
				:provider="provider"
				:booking-pass="pass"
			/>
		</div>
	</modal>
</template>

<script>
import RootStore from '../stores/root';
import { mapActions, mapGetters } from 'vuex';
import BookingPassContent from './booking_passes/BookingPassContent.vue';
import InlinePhotoViewer from './common/InlinePhotoViewer.vue';

export default {
	store: RootStore,
	components: { BookingPassContent, InlinePhotoViewer },
	props: {
		context: { required: true, type: Object },
		provider: { required: true, type: Object },
		pass: { required: true, type: Object },
	},
	computed: {
		...mapGetters({
			allCartItems: 'cart/items',
		}),
		cartItems() {
			return this.allCartItems.filter((item) => item.itemId || item.specId);
		},
		imageItems() {
			var imageItems = [];
			if (this.pass.image) {
				imageItems.push({
					key: `item-${this.pass.image.id}`,
					imageUrl: this.context.storageEndpoint + this.pass.image.file_name
				});
			}
			return imageItems;
		},
		hasSoldOut() {
			return this.pass.total_issueable_count <= this.pass.total_issued_count;
		}
	},
	data() {
		const isMobile = window.innerWidth <= 480;
		const isPad = window.innerWidth > 480 && window.innerWidth <= 1024;
		let maxWidth = 700;
		if (isMobile) {
			maxWidth = 700;
		} else {
			if (isPad) {
				maxWidth = 560;
			} else {
				maxWidth = 640;
			}
			if (this.pass.image) {
				maxWidth -= 80;
			}
		}

		return {
			isMobile,
			maxWidth: maxWidth + 'px',
			forceHeight: isMobile ? '84vh' : '96vh',
		};
	},
	methods: {
		...mapActions({
			setItem: 'cart/setItem',
			removeBookingPass: 'cart/removeBookingPass',
			addBookingPass: 'cart/addBookingPass',
		}),
		confirm() {
			this.addBookingPass(this.pass);
			this.$emit('close');
		},
	}
}
</script>
